import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'symbol',
      label: i18n.t('common_words.symbol'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'description',
      label: i18n.t('common_words.description'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'assimilable_form',
      label: i18n.t('climate.assimilable_form'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'type',
      label: i18n.t('common_words.type'),
      minWidth: 150,
      sortable: true,
    },
  ];

  return { Table };
};

export default configTable;
